<template>
    <div class="home">
        <div v-if="showSplash && splashAd" class="splash-mask" @click.self="closeSplash">
            <div class="splash-box">
                <a :href="splashAd.url || 'javascript:void(0)'" target="_blank" rel="noopener noreferrer">
                    <img :src="splashAd.pic" alt="" />
                </a>
                <div class="splash-close" @click="closeSplash">关闭</div>
            </div>
        </div>

        <section class="carousel-card">
            <van-swipe class="my-swipe" :autoplay="3000" lazy-render touchable>
                <van-swipe-item v-for="item in swiperArr" :key="item.id">
                    <a href="javascript:void(0)" @click="goSwiperLink(item)">
                        <img :src="item.pic" alt="" class="slide-img">
                    </a>
                </van-swipe-item>
            </van-swipe>
        </section>

        <van-notice-bar
            class="notice-strip"
            scrollable
            mode="closeable"
            left-icon="volume-o"
            :text="webInfo.notice || '欢迎使用应用导航 B'"
        />

        <div class="content-box">
            <main-nav></main-nav>

            <home-slide :dataList="hotList"></home-slide>
        </div>

        <div
            v-for="(item, index) in homeFloatAds"
            :key="`float-${item.id || index}`"
            class="home-float-ad"
            :class="index % 2 === 0 ? 'is-right' : 'is-left'"
            :style="{ top: `${36 + Math.floor(index / 2) * 22}%` }"
        >
            <a :href="item.url || 'javascript:void(0)'" target="_blank" rel="noopener noreferrer">
                <img :src="item.pic" alt="" />
            </a>
            <div class="close" @click="removeFloatAd(index)">x</div>
        </div>

        <div v-if="homeBottomAds.length" class="home-bottom-ad-wrap">
            <div v-for="(item, index) in homeBottomAds" :key="`bottom-${item.id || index}`" class="home-bottom-ad">
                <a :href="item.url || 'javascript:void(0)'" target="_blank" rel="noopener noreferrer">
                    <img :src="item.pic" alt="" />
                </a>
                <div class="close" @click="removeBottomAd(index)">x</div>
            </div>
        </div>
    </div>
</template>

<script>
import HomeSlide from "@/components/Slide.vue"
import MainNav from "@/components/MainNav.vue"

export default {
    components: {
        MainNav,
        HomeSlide
    },
    data() {
        return {
            webInfo: {
                title: "网站标题",
                notice: "这里是公告,点击右侧 x 按钮可关闭哦"
            },
            swiperArr: [],
            hotList: [],
            homeFloatAds: [],
            homeBottomAds: [],
            splashAd: null,
            showSplash: false
        }
    },
    methods: {
        // 网站信息
        async getSet() {
            const { data: res } = await this.$http.get('/set')
            this.webInfo = res.data[0]
        },
        // 轮播
        async getSwiperList() {
            const { data: res } = await this.$http.get('/swiper_list')
            this.swiperArr = res.data
        },
        // 热门推荐
        async getHotList() {
            const { data: classifyRes } = await this.$http.get('/classify')

            const classifyList = Array.isArray(classifyRes.data) ? classifyRes.data : []
            const categoryList = classifyList
                .map((item) => String(item.classify || '').trim())
                .filter(Boolean)

            const responseList = await Promise.all(
                categoryList.map((className) => this.$http.get('/list_class', {
                    params: { class: className }
                }))
            )

            const mergedList = responseList
                .flatMap(({ data }) => Array.isArray(data.data) ? data.data : [])
                .filter((item, index, arr) => arr.findIndex((row) => Number(row.id) === Number(item.id)) === index)

            const hasAnyClicks = mergedList.some((item) => Number(item.num || 0) > 0)
            const fallbackList = mergedList
                .slice()
                .sort(() => Math.random() - 0.5)

            this.hotList = (hasAnyClicks
                ? mergedList.slice().sort((first, second) => Number(second.num || 0) - Number(first.num || 0))
                : fallbackList
            ).slice(0, 36)
        },
        async goSwiperLink(item) {
            if (!item || !item.url) return
            try {
                await this.$http.post('/track_click', {
                    target_type: 'swiper',
                    target_id: item.id
                })
            } catch (error) {
                // 统计失败不阻断跳转
            }
            window.open(item.url, '_blank')
        },
        async getAdSlot(adType) {
            const { data: res } = await this.$http.get('/ad_slot_list', {
                params: { ad_type: adType }
            })
            return res.data || []
        },
        normalizeAdsByType(list, adType) {
            if (!Array.isArray(list)) return []
            return list.filter((item) => {
                const type = String(item?.ad_type || '').trim()
                const pic = String(item?.pic || '').trim()
                return type === adType && !!pic
            })
        },
        async getHomeAds() {
            try {
                const [floatList, bottomList, splashList] = await Promise.all([
                    this.getAdSlot('home_float'),
                    this.getAdSlot('home_bottom'),
                    this.getAdSlot('splash')
                ])
                this.homeFloatAds = this.normalizeAdsByType(floatList, 'home_float')
                this.homeBottomAds = this.normalizeAdsByType(bottomList, 'home_bottom')
                this.splashAd = this.normalizeAdsByType(splashList, 'splash')[0] || null

                const splashShown = sessionStorage.getItem('home_splash_shown')
                if (this.splashAd && splashShown !== '1') {
                    this.showSplash = true
                    sessionStorage.setItem('home_splash_shown', '1')
                }
            } catch (error) {
                this.homeFloatAds = []
                this.homeBottomAds = []
                this.splashAd = null
            }
        },
        removeFloatAd(index) {
            this.homeFloatAds.splice(index, 1)
        },
        removeBottomAd(index) {
            this.homeBottomAds.splice(index, 1)
        },
        closeSplash() {
            this.showSplash = false
        }
    },
    created() {
        this.getSet()
        this.getSwiperList()
        this.getHotList()
        this.getHomeAds()
    }
}
</script>

<style lang="less" scoped>
.my-swipe {
    width: 100%;
    height: 14.8rem;
}

.home {
    position: relative;
    z-index: 2;
}

.carousel-card {
    padding: .6rem;
    border-radius: var(--a-radius);
    background: linear-gradient(145deg, rgba(15, 23, 42, 0.96), rgba(10, 16, 35, 0.95));
    border: 1px solid rgba(34, 211, 238, 0.18);
    box-shadow: var(--a-shadow);
}

.slide-img {
    width: 100%;
    height: 14.8rem;
    object-fit: contain;
    background: #f7f8fa;
    border-radius: .95rem;
    filter: saturate(1.16) contrast(1.05);
    border: 1px solid rgba(139, 92, 246, 0.2);
}

.notice-strip {
    margin-top: .45rem;
    border-radius: 999px;
    color: #e2e8f0;
    font-size: 1rem;
    line-height: 1.3rem;
    height: 2.8rem;
    border: 1px solid rgba(34, 211, 238, 0.2);
    background: rgba(15, 23, 42, 0.8);
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.04);
}

.content-box {
    padding: .5rem 0 0;
    display: grid;
    gap: .75rem;
}

.home-float-ad {
    position: fixed;
    width: 5.2rem;
    z-index: 998;
    &.is-right {
        right: .45rem;
    }
    &.is-left {
        left: .45rem;
    }
    img {
        width: 100%;
        border-radius: .65rem;
        box-shadow: 0 12px 26px rgba(2, 6, 23, 0.45);
    }
    .close {
        text-align: center;
        font-size: .9rem;
        color: #fff;
        background: rgba(139, 92, 246, 0.82);
        border-radius: .3rem;
        margin-top: .2rem;
    }
}
.home-bottom-ad-wrap {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 5.2rem;
    width: calc(100% - 1rem);
    max-width: 740px;
    z-index: 997;
    display: flex;
    flex-direction: column;
    gap: .35rem;
}

.home-bottom-ad {
    position: relative;
    img {
        width: 100%;
        height: 4.4rem;
        object-fit: contain;
        background: #f7f8fa;
        border-radius: .75rem;
        box-shadow: 0 12px 24px rgba(2, 6, 23, 0.4);
    }
    .close {
        position: absolute;
        right: .2rem;
        top: .2rem;
        width: 1.2rem;
        line-height: 1.2rem;
        text-align: center;
        color: #fff;
        font-size: .8rem;
        border-radius: 50%;
        background: rgba(34, 211, 238, 0.8);
    }
}

.splash-mask {
    position: fixed;
    inset: 0;
    z-index: 1200;
    background: rgba(11, 24, 46, .56);
    display: flex;
    align-items: center;
    justify-content: center;
    .splash-box {
        width: calc(100% - 2rem);
        max-width: 420px;
        animation: fade-up .36s ease;
        img {
            width: 100%;
            border-radius: 1rem;
            box-shadow: 0 16px 30px rgba(0, 0, 0, .36);
        }
        .splash-close {
            margin-top: .7rem;
            line-height: 2rem;
            text-align: center;
            color: #fff;
            border: 1px solid #fff;
            border-radius: 2rem;
            font-size: .95rem;
        }
    }
}

@keyframes fade-up {
    0% {
        opacity: 0;
        transform: translateY(10px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@media screen and (max-width: 480px) {
    .home-float-ad,
    .home-bottom-ad-wrap {
        display: none;
    }
}
</style>